import React from 'react';
import { setTimeout } from 'timers';
import { CSSTransition } from 'react-transition-group' 
import { Localize } from "../shared/localize.js";

class WarningCompile extends React.Component {
  constructor(props) {
    super(props);

/*
    this.state = {
      isOpen: false
    };

    var self = this;

    setTimeout(function () {
      self.setState({ isOpen: true });
    }, 3000);
*/
  }

  render() {
    var ret = null;

    ret = (
      <CSSTransition
        in={true}
        appear={true}
        classNames="bounceInRightSlow"
        timeout={10500}
      >
      <div className="text-center" style={{ backgroundColor: "#FFF09E", boxShadow: "0 2px 14px 0 rgba(0,0,0,0.13)" }}>
        <div className="pt-4 pb-4" style={{ color: "#464646", fontSize: "16px", lineHeight: "19px", fontWeight: "500" }}>
            <span className="pr-3"><i className="fa fa-exclamation-circle"></i></span> {Localize.L("Compila tutto il form per visualizzare i cerchi migliori per la tua auto.")}
        </div>
      </div>
      </CSSTransition>
    );

/*
    if (this.state.isOpen) {
      ret = (
        <div className="text-center" style={{ backgroundColor: "#FFF09E", boxShadow: "0 2px 14px 0 rgba(0,0,0,0.13)" }}>
          <div className="pt-4 pb-4" style={{ color: "#464646", fontSize: "16px", lineHeight: "19px", fontWeight: "500" }}>
            <span className="pr-3"><i className="fa fa-exclamation-circle"></i></span> Compila tutto il form per visualizzare i cerchi migliori per la tua auto.
        </div>
        </div>
      );
    }
*/

    return ret;
  }
}

export { WarningCompile }
